var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4607_143602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.87875 0 3.8425 0.843375 2.34375 2.34313C0.843465 3.84348 0.000429311 5.87823 0 8C0 10.1209 0.84375 12.1571 2.34375 13.6569C3.8425 15.1566 5.87875 16 8 16C10.1213 16 12.1575 15.1566 13.6562 13.6569C15.1562 12.1571 16 10.1209 16 8C16 5.87913 15.1562 3.84288 13.6562 2.34313C12.1575 0.843375 10.1213 0 8 0Z",
    fill: "url(#paint0_linear_4607_143602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62058 7.91602C5.95308 6.90002 7.50808 6.23018 8.28558 5.90652C10.5081 4.98239 10.9693 4.82189 11.2706 4.81645C11.3368 4.81539 11.4843 4.83177 11.5806 4.90958C11.6606 4.9752 11.6831 5.06395 11.6943 5.12627C11.7043 5.18852 11.7181 5.33039 11.7068 5.44114C11.5868 6.70614 11.0656 9.77589 10.8006 11.1928C10.6893 11.7923 10.4681 11.9933 10.2543 12.0129C9.78933 12.0556 9.43683 11.7059 8.98683 11.411C8.28308 10.9494 7.88558 10.6621 7.20183 10.2118C6.41183 9.69127 6.92433 9.40514 7.37433 8.93764C7.49183 8.81527 9.53933 6.95339 9.57808 6.78452C9.58308 6.76339 9.58808 6.68464 9.54058 6.64314C9.49433 6.60152 9.42558 6.61577 9.37558 6.62702C9.30433 6.64302 8.18058 7.38652 6.00058 8.85739C5.68183 9.07664 5.39308 9.18352 5.13308 9.17789C4.84808 9.17177 4.29808 9.01639 3.88933 8.88364C3.38933 8.72077 2.99058 8.63464 3.02558 8.35802C3.04308 8.21402 3.24183 8.06664 3.62058 7.91602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4607_143602",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 1600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4607_143602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersTelegram);
export default __webpack_public_path__ + "static/media/partners-telegram.e14b06cd58769c3df4ea76aa1594ac3d.svg";
export { ForwardRef as ReactComponent };